import $ from 'jquery';

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const $header = $('#header');
	const $headerNav = $('#header-nav');
	const headerToggler = $headerNav.data('toggler');

	if (headerToggler) {

		headerToggler.on('toggle', function() {
			$html.toggleClass('is-header-open', headerToggler.isOpen);

			const top = $header.offset().top;

			if (headerToggler.isOpen) {
				$scroller.animate({ scrollTop: top }, { duration: 200 });
				}
		});
	}

	$('.header_nav > .nav_wrapper > ul > li.-parent > a[href]').click(function(e) {
		if ($(window).width() > 1080) return;
		e.preventDefault();
		$('.header_nav .nav_services').removeClass('is-open');
		$(this).next().addClass('is-open');
		$('.header_nav').addClass('is-descendant-open');
	});

	$('.header_nav .nav_services_close').click(function() {
		$(this).parents('.nav_services').removeClass('is-open');
		$('.header_nav').removeClass('is-descendant-open');
	});

	$('.header_nav a[href="#quote"]').click(function(e) {
		$('.header_nav').data('toggler').close();
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js